import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="question-bubble"
// Handles clicking on question number bubbles to navigate between questions
export default class extends Controller {
  static values = {
    qnumber: Number,
    setupNumber: Number
  }

  click(event) {
    event.preventDefault()

    const $ = window.$
    if (!$) {
      console.warn('[question-bubble] jQuery not available')
      return
    }

    const questionNumber = this.qnumberValue || this.element.getAttribute('data-qnumber')
    const setupNumber = this.setupNumberValue || this.element.getAttribute('data-setup-number')

    if (!questionNumber) {
      console.warn('[question-bubble] Missing question number')
      return
    }

    console.log('[question-bubble] Bubble clicked', {
      questionNumber: questionNumber,
      setupNumber: setupNumber,
      element: this.element
    })

    // Reset all bubble font weights to normal
    $(".interface-bottom-bubble-wrap-yash").css("fontWeight", "normal")
    // Set clicked bubble to bold
    $(this.element).css("fontWeight", 700)

    // Hide all question containers
    $(".interface-questions-container-holder-yash").css("display", "none")
    // Show the selected question container
    $("#interface-questions-container-holder-" + questionNumber + "-yash").css("display", "block")

    // Remove current bubble indicator from all bubbles
    $(".interface-bottom-current-bubble-yash").removeClass("interface-black-yash")
    // Add current bubble indicator to clicked bubble
    const currentBubble = $("#interface-bottom-current-bubble-" + questionNumber + "-yash")
    currentBubble.addClass("interface-black-yash")

    // Change the current setup (for games/comp sections)
    if (setupNumber) {
      $(".interface-setup-container-yash").css("display", "none")
      $("#interface-setup-container-" + setupNumber + "-yash").css("display", "block")
    }

    // Update time tracking for the previous question
    const currentQuestion = window.currentQuestion
    if (currentQuestion && currentQuestion.startTime != 0) {
      const timeClicked = new Date().getTime()
      const timeToAdd = timeClicked - currentQuestion.startTime // the amount of time spent on this setup before the user clicked it this time
      const totalTimeSpent = timeToAdd + Number($("#time-spent-" + currentQuestion.number + "-yash").val())
      $("#time-spent-" + currentQuestion.number + "-yash").val(totalTimeSpent)
    }

    // Update currentQuestion
    if (currentQuestion) {
      currentQuestion.change(parseInt(questionNumber))
      currentQuestion.startTime = new Date().getTime()
    }

    // Handle flag display (matching original logic)
    const bubbleIndex = parseInt(questionNumber) - 1
    if (currentBubble.hasClass("bottom-interface-flag-unclicked-yash") ||
        currentBubble.hasClass("bottom-interface-flag-clicked-yash")) {
      // Remove flag class from all bubbles
      $(".interface-bottom-current-bubble-yash").removeClass("bottom-interface-flag-clicked-yash")
      // Add both flag classes to current bubble (matching original behavior)
      currentBubble
        .removeClass("interface-black-yash")
        .addClass("bottom-interface-flag-unclicked-yash bottom-interface-flag-clicked-yash")
    } else {
      // Remove flag class from all bubbles
      $(".interface-bottom-current-bubble-yash").removeClass("bottom-interface-flag-clicked-yash")
    }

    // Load highlights for images (matching original setTimeout logic)
    setTimeout(() => {
      if (typeof window.highlightFeature === 'function') {
        // Get image data from script tag if available
        let imageData = undefined
        const scriptTag = document.getElementById('lsat-section-image-data')
        if (scriptTag && scriptTag.textContent) {
          try {
            const rawJson = scriptTag.textContent.trim()
            // Check if it's a valid JSON string (starts with { and ends with })
            if (rawJson.startsWith('{') && rawJson.endsWith('}')) {
              // Try to parse the JSON
              const parsed = JSON.parse(rawJson)
              // Only use if it's a valid object with at least one key
              if (parsed && typeof parsed === 'object' && Object.keys(parsed).length > 0) {
                // Filter out null/undefined values
                const validKeys = Object.keys(parsed).filter(key => parsed[key] != null)
                if (validKeys.length > 0) {
                  imageData = parsed
                }
              }
            } else {
              console.warn('[question-bubble] imageData does not look like valid JSON:', rawJson.substring(0, 50))
            }
          } catch (e) {
            // Only log if it's not an empty object or obvious invalid JSON
            const rawValue = scriptTag.textContent.trim()
            if (rawValue && rawValue !== '' && rawValue !== '{}') {
              console.warn('[question-bubble] Could not parse image data', e, {
                rawValue: rawValue.substring(0, 100),
                rawValueLength: rawValue.length
              })
            }
          }
        }

        if (imageData !== undefined) {
          const setupImageElement = $("#interface-setup-container-" + setupNumber + "-yash").find(".interface-highlight-container-yash").get(0)
          const questionImageElement = $("#interface-questions-container-holder-" + questionNumber + "-yash").find(".interface-highlight-container-yash").get(0)

          if (setupImageElement && questionImageElement) {
            const setupImageId = setupImageElement.id.replace("-highlight-yash", "")
            const questionImageId = questionImageElement.id.replace("-highlight-yash", "")

            // Only load highlights if not the first question (matching original logic)
            if (parseInt(questionNumber) !== 1) {
              if (typeof window.loadHighlightForOneImage === 'function') {
                window.loadHighlightForOneImage(setupImageId, imageData)
                window.loadHighlightForOneImage(questionImageId, imageData)
              } else if (typeof window.highlightFeature === 'function') {
                // Fallback to highlightFeature if loadHighlightForOneImage doesn't exist
                window.highlightFeature(imageData)
              }
            }
          }
        }
      }
    }, 200)

    // Call resizePage to adjust layout after question change
    // Try to get the resizePage method from the lsat-section controller
    const lsatSectionElement = document.querySelector('[data-controller*="lsat-section"]')
    if (lsatSectionElement) {
      const lsatSectionController = this.application.getControllerForElementAndIdentifier(
        lsatSectionElement,
        'lsat-section'
      )
      if (lsatSectionController && typeof lsatSectionController.resizePage === 'function') {
        lsatSectionController.resizePage()
      }
    }

    // Fallback to window.resizePage if controller method not available
    if (typeof window.resizePage === 'function') {
      window.resizePage()
    }
  }
}
